<template>
  <input class="form-control" type="date" v-model="dateString">
</template>

<script>
import { parse, format } from "date-fns";
import log from "@/utils/logger";

export default {
  name: "DateSelector",
  props: {
    date: Date
  },
  emits: [ "update:date" ],
  computed: {
    dateString: {
      get()
      {
        if (!this.date)
        {
          return null;
        }

        if (typeof this.date === 'string')
        {
          return this.date;
        }
        return format(this.date, "yyyy-MM-dd");
      },
      set(value)
      {
        let date = null;

        if (value)
        {
          try
          {
            date = parse(value, "yyyy-MM-dd", new Date());
          }
          catch (e)
          {
            log.error("Failed to parse date value [%s] - %o", value, e);
          }
        }

        this.$emit("update:date", date);
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>